module.exports = __webpack_public_path__ + "static/img/sfzghm.f6236fef.png";